<div class="header">
    <div class="header-action" (click)="toggle(tree)">
        <div class="header-action-toggle" [ngClass]="{'active': isToggled(tree)}"
             *ngIf="tree.trees && tree.trees.length > 0">
            <fui-icon class="header-action-toggle-object" [height]="8" [icon]="'chevron-right'" [width]="6"></fui-icon>
        </div>
        <div class="header-action-media">
            <fui-icon class="header-action-media-object" [height]="14" [icon]="tree.icon" [width]="14"></fui-icon>
        </div>
        <div class="header-action-label">
            <div class="header-action-label-title">
                {{tree.title}}
            </div>
        </div>
    </div>
    <div class="header-context" *ngTemplateOutlet="treeHeaderContext; context: $any({tree: tree})"></div>
</div>
<div class="main" *ngIf="isToggled(tree)">
    <fui-tree *ngFor="let tree of tree.trees;trackBy: trackByFn" [tree]="tree" [toggled]="toggled" [attr.tree-item-label]="tree.title">
        <ng-template #treeheadercontext let-tree="tree">
            <ng-container *ngTemplateOutlet="treeHeaderContext; context: $any({tree: tree})"></ng-container>
        </ng-template>
    </fui-tree>
</div>
